<template>
    <div class="grid grid-cols-12 gap-4">
        <template v-for="(input, i) in inputs" :key="`${i}-input`">
            <div v-if="input.type != 'InputHidden' && ((input.showOnCreating && form.id == null) || (input.showOnUpdating && form.id != null)) && parent(input)"
                :class="[input.responsive.sm, input.responsive.md, input.responsive.lg, input.responsive.xl]">
                <div class="flex flex-col gap-2 mb-4">
                    <div><label v-if="input.type != 'Checkbox'" class="font-semibold w-24">{{
                        input.label }}</label></div>
                    <template v-if="input.showOnPreview">
                        <CrudCell :value="form[input.column]" :input="input" :option="option" :item="form"
                            :class="input.class ?? ''" />
                    </template>
                    <template v-else>
                        <template v-if="input.type == 'InputName'">
                            <InputText v-model="form[input.column]"
                                :invalid="form.errors && form.errors[input.column] != null"
                                :placeholder="input.placeholder" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'InputSurname'">
                            <InputText v-model="form[input.column]"
                                :invalid="form.errors && form.errors[input.column] != null"
                                :placeholder="input.placeholder" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'InputFullname'">
                            <InputText v-model="form[input.column]"
                                :invalid="form.errors && form.errors[input.column] != null"
                                :placeholder="input.placeholder" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'InputEmail'">
                            <InputText v-model="form[input.column]"
                                :invalid="form.errors && form.errors[input.column] != null"
                                :placeholder="input.placeholder" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'InputCompany'">
                            <InputText v-model="form[input.column]"
                                :invalid="form.errors && form.errors[input.column] != null"
                                :placeholder="input.placeholder" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'InputTitle'">
                            <InputText v-model="form[input.column]"
                                :invalid="form.errors && form.errors[input.column] != null"
                                :placeholder="input.placeholder" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'Icons'">
                            <Select :editable="input.filter" v-model="form[input.column]" :loading="input.loading"
                                :invalid="form.errors && form.errors[input.column] != null"
                                @keyup="(e) => $emit('setFilter', e, input)" :options="input.options"
                                :optionLabel="input.optionLabel" :optionValue="input.optionValue"
                                :showClear="input.clear" :placeholder="input.placeholder" checkmark
                                :highlightOnSelect="false" class="w-full" :class="input.class ?? ''">

                                <template #option="slotProps">
                                    <div v-if="slotProps.option" class="flex items-center gap-2">
                                        <i :class="slotProps.option.value"></i>
                                        <div>{{ slotProps.option.name }}</div>
                                    </div>
                                </template>
                            </Select>


                        </template>
                        <template v-else-if="input.type == 'InputCountry'">
                            <Select filter v-model="form[input.column]" @change="(e) => setCountry(e, input)"
                                :invalid="form.errors && form.errors[input.column] != null" :options="input.options"
                                :optionLabel="input.optionLabel" :optionValue="input.optionValue"
                                :placeholder="input.placeholder" checkmark :highlightOnSelect="false" class="w-full"
                                :class="input.class ?? ''" />


                        </template>

                        <template v-else-if="input.type == 'InputCity'">
                            <Select filter v-model="form[input.column]" @change="(e) => setCity(e, input)"
                                :invalid="form.errors && form.errors[input.column] != null" :options="input.options"
                                :optionLabel="input.optionLabel" :optionValue="input.optionValue"
                                :placeholder="input.placeholder" checkmark :highlightOnSelect="false" class="w-full"
                                :class="input.class ?? ''" />
                        </template>

                        <template v-else-if="input.type == 'InputDistrict'">
                            <Select filter v-model="form[input.column]"
                                :invalid="form.errors && form.errors[input.column] != null" :options="input.options"
                                :optionLabel="input.optionLabel" :optionValue="input.optionValue"
                                :placeholder="input.placeholder" checkmark :highlightOnSelect="false" class="w-full"
                                :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'Typeahead'">
                            <AutoComplete v-model="form[input.column]" @change="(e) => typeaheadChange(input)"
                                :invalid="form.errors && form.errors[input.column] != null" class="flex-auto" multiple
                                fluid :typeahead="false" :placeholder="input.placeholder" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'Checkbox'">
                            <div class="flex justify-start items-center gap-4">
                                <div>
                                    <Checkbox v-model="form[input.column]" binary
                                        :invalid="form.errors && form.errors[input.column] != null"
                                        :class="input.class ?? ''" />
                                </div>

                                <Message v-if="form.errors && form.errors[input.column]" severity="error" size="small"
                                    variant="simple">
                                    <div class="checkbox-text" v-html="form.errors[input.column]"></div>
                                </Message>
                                <div v-else class="checkbox-content" v-html="input.label"></div>
                            </div>
                        </template>
                        <template v-else-if="input.type == 'ColorPicker'">
                            <ColorPicker v-model="form[input.column]" inline format="hex"
                                :invalid="form.errors && form.errors[input.column] != null"
                                :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'PhoneNumber'">
                            <vue-tel-input :value="form[input.column]"
                                @validate="(phone) => phoneChange(phone, input.column)"
                                :class="form.errors && form.errors[input.column] ? 'phone-invalid' : ''"
                                :inputOptions="{ id: `${input.column}-${i}`, placeholder: input.placeholder }">
                            </vue-tel-input>

                        </template>
                        <template v-else-if="input.type == 'InputText'">
                            <InputText v-model="form[input.column]" v-uppercase="input.uppercase"
                                :invalid="form.errors && form.errors[input.column] != null"
                                :placeholder="input.placeholder" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'Textarea'">
                            <Textarea v-model="form[input.column]"
                                :invalid="form.errors && form.errors[input.column] != null" :rows="input.rows ?? 3"
                                :placeholder="input.placeholder" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'InputMask'">
                            <InputMask v-model="form[input.column]"
                                :invalid="form.errors && form.errors[input.column] != null"
                                :mask="input.mask ?? '(999) 999-9999'" :placeholder="input.placeholder"
                                :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'InputNumber'">
                            <InputNumber :useGrouping="false" fluid v-model="form[input.column]" :min="input.min"
                                :max="input.max" :invalid="form.errors && form.errors[input.column] != null"
                                :placeholder="input.placeholder" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'InputNumberStepper'">
                            <InputNumber v-model="form[input.column]" fluid
                                :invalid="form.errors && form.errors[input.column] != null"
                                :placeholder="input.placeholder" showButtons buttonLayout="horizontal"
                                :step="input.step" :min="input.min" :max="input.max">
                                <template #incrementbuttonicon>
                                    <span class="pi pi-plus" :class="input.class ?? ''" />
                                </template>
                                <template #decrementbuttonicon>
                                    <span class="pi pi-minus" :class="input.class ?? ''" />
                                </template>
                            </InputNumber>
                        </template>
                        <template v-else-if="input.type == 'InputCurrency'">
                            <InputNumber v-model="form[input.column]" fluid mode="currency"
                                :currency="input.currency ?? 'USD'"
                                :invalid="form.errors && form.errors[input.column] != null"
                                :placeholder="input.placeholder" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'InputNumberPrefixSuffix'">
                            <InputNumber v-model="form[input.column]" fluid
                                :invalid="form.errors && form.errors[input.column] != null"
                                :placeholder="input.placeholder" :prefix="input.prefix" :suffix="input.suffix"
                                :min="input.min" :max="input.max" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'InputOpt'">
                            <InputOtp v-model="form[input.column]" :length="input.length ?? 4"
                                :invalid="form.errors && form.errors[input.column] != null"
                                :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'InputSwitch'">
                            <ToggleSwitch v-model="form[input.column]"
                                :invalid="form.errors && form.errors[input.column] != null"
                                :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'DatePicker'">
                            <VueDatePicker v-model="form[input.column]" model-type="format" auto-apply
                                :hide-navigation="['time']" :teleport="true"
                                :state="!(form.errors && form.errors[input.column] != null)" :format="input.format"
                                :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'DateTimePicker'">
                            <VueDatePicker v-model="form[input.column]" auto-apply model-type="format"
                                :state="!(form.errors && form.errors[input.column] != null)" :teleport="true"
                                :format="input.format" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'MonthPicker'">
                            <VueDatePicker v-model="form[input.column]" month-picker auto-apply :teleport="true"
                                model-type="format" :state="!(form.errors && form.errors[input.column] != null)"
                                :format="input.format" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'RangePicker'">
                            <VueDatePicker v-model="form[input.column]" range auto-apply model-type="format"
                                :state="!(form.errors && form.errors[input.column] != null)" :teleport="true"
                                :format="input.format" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'TimePicker'">
                            <VueDatePicker v-model="form[input.column]" time-picker auto-apply model-type="format"
                                :state="!(form.errors && form.errors[input.column] != null)" :teleport="true"
                                :format="input.format" :class="input.class ?? ''" />
                        </template>

                        <template v-else-if="input.type == 'YearPicker'">
                            <VueDatePicker v-model="form[input.column]" year-picker auto-apply model-type="format"
                                :state="!(form.errors && form.errors[input.column] != null)" :teleport="true"
                                :format="input.format" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'Editor'">
                            <Editor v-model="form[input.column]" name="content"
                                :editorStyle="`height:${input.height ?? '320'}px`">
                                <template v-if="input.toolbar != null" v-slot:toolbar>
                                    <span class="ql-formats">
                                        <select v-if="input.toolbar.font" class="ql-font"></select>
                                        <select v-if="input.toolbar.size" class="ql-size"></select>

                                        <button v-if="input.toolbar['bold']" class="ql-bold"></button>
                                        <button v-if="input.toolbar.italic" class="ql-italic"></button>
                                        <button v-if="input.toolbar.underline" class="ql-underline"></button>
                                        <button v-if="input.toolbar.strike" class="ql-strike"></button>

                                        <select v-if="input.toolbar.color" class="ql-color"></select>
                                        <select v-if="input.toolbar.background" class="ql-background"></select>

                                        <button v-if="input.toolbar.sub" class="ql-script" value="sub"></button>
                                        <button v-if="input.toolbar.super" class="ql-script" value="super"></button>

                                        <select v-if="input.toolbar.header" class="ql-header"></select>
                                        <button v-if="input.toolbar.blockquote" class="ql-blockquote"></button>
                                        <button v-if="input.toolbar.block" class="ql-code-block"></button>

                                        <button v-if="input.toolbar.ordered" class="ql-list" value="ordered"></button>
                                        <button v-if="input.toolbar.bullet" class="ql-list" value="bullet"></button>
                                        <button v-if="input.toolbar.indentp" class="ql-indent" value="-1"></button>
                                        <button v-if="input.toolbar.indentm" class="ql-indent" value="+1"></button>

                                        <button v-if="input.toolbar.direction" class="ql-direction"
                                            value="rtl"></button>
                                        <select v-if="input.toolbar.align" class="ql-align"></select>

                                        <button v-if="input.toolbar.link" class="ql-link"></button>
                                        <button v-if="input.toolbar.image" class="ql-image"></button>
                                        <button v-if="input.toolbar.video" class="ql-video"></button>
                                        <button v-if="input.toolbar.formula" class="ql-formula"></button>

                                        <button v-if="input.toolbar.clean" class="ql-clean"></button>
                                    </span>
                                </template>
                            </Editor>
                            <span v-if="input.hint_text" class="text-sm hint_text">{{ input.hint_text }}</span>
                        </template>
                        <template v-else-if="input.type == 'Listbox'">
                            <Listbox v-model="form[input.column]"
                                :invalid="form.errors && form.errors[input.column] != null"
                                :options="input.options ?? []" :optionLabel="input.optionLabel"
                                :optionValue="input.optionValue" class="w-full" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'MultiSelect'">
                            <MultiSelect v-model="form[input.column]"
                                :invalid="form.errors && form.errors[input.column] != null"
                                :display="input.chip ? 'chip' : 'comma'" :optionLabel="input.optionLabel"
                                :showClear="input.clear" :optionValue="input.optionValue" :options="input.options ?? []"
                                filter :placeholder="input.placeholder" :maxSelectedLabels="input.length ?? 3"
                                class="w-full" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'MultiSelectChip'">
                            <MultiSelect v-model="form[input.column]" display="chip"
                                :invalid="form.errors && form.errors[input.column] != null"
                                :optionLabel="input.optionLabel" :showClear="input.clear"
                                :optionValue="input.optionValue" :options="input.options ?? []" filter
                                :placeholder="input.placeholder" :maxSelectedLabels="input.length ?? 3" class="w-full"
                                :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'InputPassword'">
                            <Password v-model="form[input.column]" fluid
                                :invalid="form.errors && form.errors[input.column] != null" :feedback="false"
                                :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'RadioButton'">
                            <div class="flex flex-wrap gap-4">
                                <template v-for="(option, i) in input.options" :key="`${i}-radio`">
                                    <div class="flex items-center gap-2">
                                        <RadioButton v-model="form[input.column]"
                                            :invalid="form.errors && form.errors[input.column] != null"
                                            :inputId="`radio-input-${i}`" :value="option" :class="input.class ?? ''" />
                                        <label :for="`radio-input-${i}`">{{ option }}</label>
                                    </div>
                                </template>
                            </div>
                        </template>
                        <template v-else-if="input.type == 'Rating'">
                            <Rating v-model="form[input.column]"
                                :invalid="form.errors && form.errors[input.column] != null" :stars="input.length ?? 5"
                                :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'Select'">
                            <Select filter v-model="form[input.column]"
                                :invalid="form.errors && form.errors[input.column] != null"
                                @change="(e) => $emit('setChild', e, input)" :options="input.options"
                                :showClear="input.clear" :optionLabel="input.optionLabel"
                                :optionValue="input.optionValue" :placeholder="input.placeholder" checkmark
                                :highlightOnSelect="false" class="w-full" :class="input.class ?? ''">
                            </Select>
                        </template>
                        <template v-else-if="input.type == 'SelectButton'">
                            <SelectButton v-model="form[input.column]" :fluid="true"
                                :invalid="form.errors && form.errors[input.column] != null" size="small"
                                @change="(e) => $emit('setChild', e, input)" :options="input.options"
                                :optionLabel="input.optionLabel" :optionValue="input.optionValue"
                                :multiple="input.multiple" :highlightOnSelect="false" class="w-full"
                                :class="input.class ?? ''">
                            </SelectButton>
                        </template>

                        <template v-else-if="input.type == 'SelectHtml'">
                            <Select filter v-model="form[input.column]"
                                :invalid="form.errors && form.errors[input.column] != null"
                                @change="(e) => $emit('setChild', e, input)" :options="input.options"
                                :showClear="input.clear" :optionLabel="input.optionLabel"
                                :optionValue="input.optionValue" :placeholder="input.placeholder" checkmark
                                :highlightOnSelect="false" class="w-full" :class="input.class ?? ''">
                                <template #option="slotProps">
                                    <span v-if="slotProps.option" class="flex w-full"
                                        v-html="slotProps.option[input.optionLabel]">
                                    </span>
                                </template>
                                <template #value="slotProps">
                                    <span v-if="slotProps.value" class="flex w-full" v-html="input.options?.find(
                                        (option) => option[input.optionValue] === slotProps.value
                                    )?.[input.optionLabel] || ''"></span>

                                </template>
                            </Select>
                        </template>


                        <template v-else-if="input.type == 'Searchable'">
                            <Select :editable="input.filter" v-model="form[input.column]" :loading="input.loading"
                                :invalid="form.errors && form.errors[input.column] != null"
                                @keyup="(e) => $emit('setFilter', e, input)" :options="input.options"
                                :optionLabel="input.optionLabel" :optionValue="input.optionValue"
                                :showClear="input.clear" :placeholder="input.placeholder" checkmark
                                :highlightOnSelect="false" class="w-full" :class="input.class ?? ''">
                            </Select>

                        </template>

                        <template v-else-if="input.type == 'Slider'">
                            <Slider v-model="form[input.column]" class="w-56" :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'ToggleButton'">
                            <ToggleButton v-model="form[input.column]" :onLabel="input.onLabel ?? 'Locked'"
                                :offLabel="input.offLabel ?? 'Unlocked'" :onIcon="input.iconOn ?? 'pi pi-lock'"
                                :offIcon="input.iconOff ?? 'pi pi-lock-open'" class="w-36"
                                :invalid="form.errors && form.errors[input.column] != null"
                                :class="input.class ?? ''" />
                        </template>
                        <template v-else-if="input.type == 'OrderList'">
                            <OrderList v-model="form[input.column]" :dataKey="input.optionValue"
                                :breakpoint="`${input.height ?? 575}px`" pt:pcListbox:root="w-full">
                                <template #option="{ option }">
                                    {{ option[input.optionLabel] }}
                                </template>
                            </OrderList>
                        </template>
                        <template v-else-if="input.type == 'FileUpload' || input.type == 'InputPhoto'">
                            <Dashboard class="editor" :uppy="uppyInit(input)" :props="uppyProps(input)"
                                :class="input.class ?? ''" />
                        </template>

                        <template v-else-if="input.type == 'InputGroup'">

                            <InputGroup :key="input.children" v-model:errors="form.errors" :count="input.count"
                                v-model:items="form[input.column]" :inputs="input.children" :form="input.form"
                                :option="option" :column="input.column">
                            </InputGroup>
                        </template>



                        <Message v-if="form.errors && form.errors[input.column] && input.type != 'Checkbox'"
                            severity="error" size="small" variant="simple">
                            {{ form.errors[input.column] }}
                        </Message>

                        <Message v-if="input.helpText" class="helper_hint" severity="secondary" variant="simple"
                            size="small">{{
                                input.helpText }}</Message>
                    </template>

                </div>
            </div>
            <div v-if="input.divider || input.space" class="col-span-12">
                <template v-if="input.divider">
                    <Divider :align="input.dividerAlign" :type="input.divider">
                        <template v-if="input.dividerLabel">
                            <b>{{ input.dividerLabel }}</b>
                        </template>
                    </Divider>
                </template>
                <template v-else-if="input.space">
                    <div :class="`h-${input.space}`"></div>
                </template>
            </div>


        </template>
        <div class="col-span-12">
            <Message v-if="form.errors && form.errors['id']" severity="error" size="small" variant="simple">
                {{ form.errors['id'] }}
            </Message>
        </div>
    </div>
</template>
<style>
.vue-tel-input {
    border-color: var(--p-inputtext-border-color) !important;
    box-shadow: none !important;
    padding: 0px !important;
    margin: 0px !important;
    border-radius: var(--p-inputtext-border-radius) !important;
}

.phone-invalid {
    border-color: var(--p-inputtext-invalid-border-color) !important;
}

.vue-tel-input:focus {
    border-color: var(--p-inputtext-focus-border-color) !important;
}

.vue-tel-input .vti__dropdown {
    background-color: var(--p-surface) !important;
}

.dark .vti__dropdown .vti__dropdown-list {
    background: var(--p-surface-800) !important;
    border-color: var(--p-inputtext-border-color) !important;

}

.dark .vti__dropdown .vti__dropdown-list .vti__dropdown-item {
    background-color: transparent !important;
}

.dark .vti__dropdown .vti__dropdown-list .vti__dropdown-item:hover {
    background-color: var(--p-surface-900) !important;
}

.dark .vti__dropdown .vti__dropdown-list .vti__dropdown-item:focus {
    background-color: var(--p-surface-900) !important;
}

.dark .vti__dropdown .vti__dropdown-list .vti__dropdown-item:active {
    background-color: var(--p-surface-900) !important;
}

.dark .vue-tel-input {
    background-color: var(--p-inputtext-background) !important;
}

.vue-tel-input:hover {
    border-color: #6366f1 !important;
}


.dark .uppy-Dashboard .uppy-Dashboard-inner {
    background-color: var(--p-inputtext-background) !important;
    border-color: var(--p-surface-500) !important;
    color: #fff !important;
}

.dark .uppy-Dashboard-AddFiles {
    border-color: var(--p-surface-500) !important;
}

.dark .uppy-Dashboard-AddFiles-title {
    color: var(--p-text-color) !important;
}

.dark .uppy-Dashboard-progressindicators .uppy-StatusBar {
    border: none !important;
}

.dark .uppy-DashboardContent-bar {
    background-color: var(--p-inputtext-background) !important;
    color: #fff !important;
    border: none !important;
}

.dark .uppy-StatusBar-progress {
    background-color: var(--p-inputtext-background) !important;
    color: #fff !important;
    border: none !important;
}

.dark .uppy-StatusBar-actions {
    background-color: var(--p-inputtext-background) !important;
    color: #fff !important;
    border: none !important;
}

.uppy-Dashboard-Item-previewIcon {
    z-index: 99 !important;
}

.uppy-StatusBar {
    z-index: 99 !important;
}

.uppy-StatusBar-actions {
    z-index: 99 !important;
}


.p-select-label {
    border: none !important;
    border-top-left-radius: var(--p-inputtext-border-radius) !important;
    border-bottom-left-radius: var(--p-inputtext-border-radius) !important;
}



.dp__theme_light {
    --dp-background-color: var(--p-inputtext-background) !important;
    --dp-text-color: var(--p-text-color) !important;
    --dp-hover-color: var(--p-surface-200) !important;
    --dp-hover-text-color: var(--p-text-color) !important;
    --dp-hover-icon-color: var(--p-text-color) !important;
    --dp-primary-color: var(--p-primary-color) !important;
    --dp-primary-disabled-color: var(--p-primary-color-disabled) !important;
    --dp-primary-text-color: #fff !important;
    --dp-secondary-color: var(--p-secondary-color) !important;
    --dp-border-color: #var(--p-inputtext-border-color) !important;
    --dp-menu-border-color: var(--p-inputtext-border-color) !important;
    --dp-border-color-hover: var(--p-inputtext-hover-border-color) !important;
    --dp-border-color-focus: var(--p-inputtext-focus-border-color) !important;
    --dp-disabled-color: var(--p-disabled-color) !important;
    --dp-scroll-bar-background: var(--p-inputtext-background) !important;
    --dp-scroll-bar-color: var(--p-inputtext-border-color) !important;
    --dp-success-color: var(--p-success-color) !important;
    --dp-success-color-disabled: var(--p-success-color-disabled) !important;
    --dp-icon-color: var(--p-text-color) !important;
    --dp-danger-color: var(--p-error-color) !important;
    --dp-marker-color: var(--p-error-color) !important;
    --dp-tooltip-color: var(--p-inputtext-background) !important;
    --dp-disabled-color-text: var(--p-disabled-color-text) !important;
    --dp-highlight-color: var(--p-primary-color) !important;
    --dp-range-between-dates-background-color: var(--p-inputtext-hover-border-color) !important;
    --dp-range-between-dates-text-color: var(--p-text-color) !important;
    --dp-range-between-border-color: var(--p-inputtext-border-color) !important;
}


.dark .dp__theme_light {
    --dp-hover-color: var(--p-surface-900);
}

.dp__input {
    background-color: var(--p-inputtext-background) !important;
    color: var(--p-text-color) !important;
    border: 1px solid var(--p-inputtext-border-color) !important;
    border-radius: var(--p-inputtext-border-radius) !important;
}

.dp__input:hover {
    border: 1px solid var(--p-inputtext-hover-border-color) !important;
}

.dp__input:focus {
    border: 1px solid var(--p-inputtext-focus-border-color) !important;
}

.dp__input_invalid {
    border: 1px solid var(--p-inputtext-invalid-border-color) !important;
}

.p-autocomplete-input-chip>input {
    box-shadow: none !important;

}
</style>

<script setup>




import { computed } from 'vue';
import { router } from '@inertiajs/vue3'
import Editor from 'primevue/editor';
import { Dashboard } from '@uppy/vue';
import Uppy from '@uppy/core';
import Webcam from '@uppy/webcam';
import ImageEditor from '@uppy/image-editor';
import XHRUpload from '@uppy/xhr-upload';
import VueDatePicker from '@vuepic/vue-datepicker';
import InputGroup from './InputGroup.vue';
import CrudCell from './Cell.vue';

const emit = defineEmits(['updateData', 'setChild', 'setFilter']);


const form = defineModel('form');
const inputs = defineModel('inputs');
const option = defineModel('option');




const phoneChange = (phone, column) => {
    if (phone.valid) {
        form.value[column] = phone.number;
        form.value[column + '_code'] = phone.countryCode;
    }
};



const uppyProps = (input) => {
    return {
        height: input.height ?? 300,
        showProgressDetails: true,
        proudlyDisplayPoweredByUppy: false,
        closeAfterFinish: false,
        hideProgressAfterFinish: true,
        inline: true

    };
};





const typeaheadChange = (input) => {
    const value = collect(form.value[input.column]).unique();
    form.value[input.column] = value.where((e) => e != null || e != '').toArray();
};

const uppyAddFile = async (uppy, name) => {
    var file = null;
    try {
        const response = await fetch(`${option.value.file_path}/${name}`); // Dosyanın URL'si
        const blob = await response.blob();
        file = new File([blob], name, { type: blob.type });
    } catch (error) {
        return null;
    }

    if (file) {
        uppy.addFile({
            source: 'local',
            name: name,
            type: file.type,
            data: file,
        });
    }
};

const parent = computed(() => (input) => {

    if (input && input.parentColumn && input.parentColumn.length > 0) {

        return input.parentColumn.some((column) => {
            if (input.parentColumnValue && input.parentColumnValue.length > 0 && form.value[column] instanceof Array) {
                return form.value[column].some((e) => input.parentColumnValue.includes(e));

            } else if (input.parentColumnValue && input.parentColumnValue.length > 0) {
                return input.parentColumnValue.includes(form.value[column]);
            } else if (form.value[column]) {
                return true;
            } else {
                return false;
            }
        });
    } else {
        return true;
    }
});


const setCountry = (e, x) => {
    inputs.value.filter((input) => input.type == 'InputCity' && input.parentColumn == x.column).forEach((input) => {
        form.value[input.column] = null;
    });
    router.post(option.value.country, { country: e.value }, {
        onSuccess: (page) => {
            inputs.value = page.props.fields.inputs;
        }
    })
};

const setCity = (e, x) => {

};






const uppyInit = (input) => {


    const mimeCategories = {
        "image": [".png", ".jpg"],
        "video": [".mp4", ".avi"],
        "font": [".ttf", ".otf"],
        "audio": [".mp3", ".wav"],
        "pdf": [".pdf"],
        "archive": [".zip", ".rar"],
        "excel": [".xls", ".xlsx"],
        "word": [".doc", ".docx"],
        "power_point": [".ppt", ".pptx"],
        "text": [".txt"],
        "other": null,
    };

    input.fileWebcam = input.accept == 'other';
    input.fileCrop = input.accept == 'image';


    const uppy = new Uppy({
        meta: { type: 'avatar' },
        restrictions: {
            maxNumberOfFiles: input.multiple ? input.max ?? 1 : 1,
            autoProceed: (input.fileCrop ? false : true),
            maxFileSize: input.maxFileSize ? input.maxFileSize : 1000000,
            allowedFileTypes: input.accept ? mimeCategories[input.accept] : null,
        },

    }).use(XHRUpload, {
        endpoint: option.value.file,
        fieldName: "file", // Yüklenen dosya adı
        headers: {
            "X-CSRF-TOKEN": $(
                'meta[name="csrf-token"]'
            ).attr("content"), // Laravel için CSRF token
        },
        getMeta: (file) => ({
            ...file.meta,
        }),
    }).on('upload-success', (file, response) => {
        if (input.multiple) {
            if (!form.value[input.column]) {
                form.value[input.column] = [];
            }
            form.value[input.column].push(response.body.value);
        } else {
            form.value[input.column] = response.body.value;
        }
    });


    if (input.fileWebcam) {
        uppy.use(Webcam);
    }

    if (input.fileCrop) {
        uppy.use(ImageEditor);
    }


    if (form.value['id'] && form.value[input.column]) {
        if (input.multiple) {
            if (!form.value[input.column]) {
                form.value[input.column] = [];
            }
            form.value[input.column].forEach((file) => {
                uppyAddFile(uppy, file);
            });
        } else {
            uppyAddFile(uppy, form.value[input.column]);

        }
    }

    uppy.on('file-removed', (file) => {
        form.value[input.column] = null;
    });

    return uppy;

};

</script>
